export const getTypesValidationMessage = (allowedFormats) => {
    var al = [...allowedFormats]
    // Add commers
    if (al.length > 2) {
        al = al.map((type, i) => {
            return i < allowedFormats.length - 2 ? `${type},` : type
        })
    }
    // Add 'or'
    if (al.length > 1) {
        var indexOneFromEnd = al.length - 1
        al.splice(indexOneFromEnd, 0, "or")
    }
    return `Your file must be a ${al.join(" ")} file`
}

export const checkJwtRole = (value) => {

    var role = getJwtClaim("role")

    if (!Array.isArray(role)) {
        return false
    }

    return role.includes(value)
}

export const checkJwtRoles = (values: string[], all: boolean = true) => {

    var role = getJwtClaim("role")

    if (!Array.isArray(role)) {
        return false
    }

    var matchedValues = values.filter(value => role.includes(value))

    if ((all && matchedValues.length === values.length) || (!all && matchedValues.length)) {
        return true
    }

    return false
}

export const getJwtClaim = (name: string) => {

    const token = window.localStorage.getItem("aora_questionnaire_jwt")

    if (token) {
        var claims = decodeJWT(token)

        if (name in claims) {
            var value = claims[name]

            // role can return a string instead of a string array if there is only one item, so always return string array
            if (value && name === "role" && !Array.isArray(value)) {
                return [value]
            }
            
            return value
        }
    }
}

export const decodeJWT = (token) => {

    var base64Url = token?.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}


export const getCookie = (cname: string) => {

        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

export const removeCookie = (cname) => {
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}